/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
import "./styles.scss";

const EmptyContent = () => {
  return (
    <Box className="charts__empty-content">
      <Box></Box>
      <Text size="xsmall">No items to show for this time frame.</Text>
    </Box>
  );
};

export default EmptyContent;
